module.exports = __webpack_public_path__ + "img/directory--avatar.2eb98cad.svg";